export const SUPPORTED_PATHNAME_FOR_SIMPLR_LIST: string[] = [
	'/',
	'/checkups/battery/battery-life',
];
